import {Suspense} from 'react';
import AppRouter from './Routes';
import ScrollToTop from 'utils/scrollToTop';
import AppProviders from 'context';
import ErrorHandler from './components/ErrorHandler';
import {SuspenseLoader} from './styled/common';

function App() {
  return (
    <AppProviders>
      <ScrollToTop />
      <Suspense fallback={<SuspenseLoader width={80} visible />}>
        <ErrorHandler>
          <AppRouter />
        </ErrorHandler>
      </Suspense>
    </AppProviders>
  );
}

export default App;
